export default __webpack_public_path__ + "static/grades2023-8dfd9644b21edda9b99e84d0b534cbd9.png";